if (typeof customElements.get("yc-tabbed-section") === "undefined") {
  class TabbedSection extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll(".yc-tabbed-section__tab");
      this.tabsContainer = this.querySelector(".yc-tabbed-section__tabs");
      //this.minHeight = 0;
      this.handleClick = this.handleClick.bind(this);
      this.setMinHeight = this.setMinHeight.bind(this);
      this.activeTabIndex = -1;

      this.breakpoint = 989; // px

      window.addEventListener("resize", this.setMinHeight);
      this.init();
      this.classList.add("js-enabled");
    }

    init() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => this.handleClick(index));
      });
      if (window.innerWidth < this.breakpoint) {
        // on mobile, we start with no tab active
        this.activateTab(-1);
      } else {
        this.activateTab(0); // Activate the first tab by default
      }
    }

    handleClick(index) {
      if (this.activeTabIndex === index) {
        if (window.innerWidth < this.breakpoint) {
          // on mobile, close the tab if it's already open
          this.closeTab(index);
        }
        return;
      }

      this.activateTab(index);

      // check if the down arrow is visible (mobile)
    }

    activateTab(index) {
      //console.log('activating tab', index);
      this.tabs.forEach((tab, i) => {
        const content = tab.querySelector(".yc-tabbed-section__tab-content");

        //console.log('tab', i, index);
        if (i === index) {
          tab.classList.add("active");
        } else {
          // only on desktop, we want to close the tab if it's already open
          if (window.innerWidth > this.breakpoint) {
            //console.log("closing tab on desktop");
            tab.classList.remove("active");
          }
        }
      });

      this.activeTabIndex = index;

      this.setMinHeight();
    }

    // only on portrait mode, we want to close the tab if it's already open
    closeTab(index) {
      this.tabs[index].classList.remove("active");
      this.activeTabIndex = -1;
      //this.setMinHeight();
    }

    setMinHeight() {
      //console.log("setting min height");

      if (window.innerWidth < this.breakpoint) {
        // on mobile, we don't need to set a min height
        this.tabsContainer.style.minHeight = `0px`;
        return;
      }

      if (this.activeTabIndex === -1) {
        this.tabsContainer.style.minHeight = `0px`;
        return;
      }

      this.minHeight =
        this.querySelector(".active .yc-tabbed-section__tab-content-inner")
          .scrollHeight || 0;

      //console.log("content height", this.minHeight);

      // get the titles height

      let titlesHeight = 0;
      this.tabs.forEach((tab) => {
        const title = tab.querySelector(".yc-tabbed-section__tab-title");
        if (title) {
          if (title.offsetHeight > titlesHeight) {
            titlesHeight = title.offsetHeight;
          }
        }
      });

      this.minHeight += titlesHeight; // 48px for padding

      // if height is more than 1000px
      if (this.minHeight > 1000) {
        this.minHeight = 1000;
      }

      this.tabsContainer.style.minHeight = `${this.minHeight}px`;

      // make sure that the tab is touching the buttons.
      this.tabs.forEach((tab) => {
        const content = tab.querySelector(".yc-tabbed-section__tab-content");
        if (content) {
          content.style.top = `${titlesHeight}px`;
        }
      });
    }
  }

  customElements.define("yc-tabbed-section", TabbedSection);
}
